<template>
    <b-row class="steps py-5">
        <b-col cols="11"  lg="10" class="mx-auto">
            <p class="steps-titulo" v-html="content.titulo"></p>
            <p class="steps-subtitulo mt-5" v-html="content.subtitulo"></p>
        </b-col>
        <b-col cols="12"  lg="12">
            <b-row 
            class="mt-3 pb-5 steps-content-block justify-content-center align-items-center" >
               
                <Block :content="content.blocks.shops"/>
                <Block :content="content.blocks.log"/>
                <Block :content="content.blocks.capta"/>
                
            </b-row>
        </b-col>
        <b-col cols="12"  lg="12" class="mt-5 pb-5 pt-5 steps-spase">
        </b-col>
    </b-row>
</template>
<script>
    import Block from '@/components/Block'

    export default {
        name: 'section-steps',
        components: {
            Block
        },
        props: {
            content: Object
        }
    }
</script>
<style scoped>

    @media (max-width: 600px) {

        .steps-titulo {
            margin: 0px;

        }

        .steps-subtitulo {
            margin: 0px;
            font-size:  20px;
        }

    }
</style>